import React, { useContext, useState, useEffect } from "react";
import GoogleLogin from "react-google-login";
import Button from "@material-ui/core/Button";
import axios from "axios";
import {
  socialLoginApi,
  socialRegisterApi,
  socialUser,
} from "../Functions/socialUser";
import DispatchContext from "../DispatchContext";
import GetPhoneNo from "./GetPhoneNo";
import google from "../Assets/images/google.png";

import StateContext from "../StateContext";
import { withTranslation, useTranslation, Trans } from "react-i18next";



function LoginGoogle({
  loginHandleclose,
  loading,
  setLoading,
  setAlertMessage,
}) {
  const appDispatch = useContext(DispatchContext);
  const appState = useContext(StateContext);
  
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [phoneNo, setPhoneNo] = useState();
  const [noStatus, setNoStatus] = useState(false);
  const [dataRes, setDataRes] = useState({
    first_name: "",
    last_name: "",
    email: "",
    id: "",
    phone_no: "",
  });
  const clientId =
    "169152409843-8mj25ltqn1h64q310d39gte30sh9qhmm.apps.googleusercontent.com";

  var userData = [];

 
  const getPhoneNo = () => {
    setOpen(true);
  };
  const handleClosePhoneNo = () => {
    setOpen(false);
  };

  const responseGoogle = async (response) => {
    setLoading(true);
    let userData = [];
    const res = await response.profileObj;
    if (res) {
      userData.push({
        loginSource: "google",
        firstName: res.givenName,
        lastName: res.familyName,
        userEmail: res.email,
        Title: "userID",
        titleValue: res.googleId,
      });
      setDataRes(res);
      let result = await socialLoginApi(
        userData,
        appDispatch,
        loginHandleclose,
        loading,
        setLoading,
        getPhoneNo
      );
    } else {
      // console.log(response);
      setLoading(false);
      loginHandleclose();
    }
    // console.log(response, "gettting");
  };

  const componentClicked = (data) => {
    // console.log(data);
    // responseGoogle();
  };

  const onFailureSuccess = (res) => {
    // console.log("onFailureSuccess", res);
  };
  const handleChangeUserInfo = (e) => {
    setDataRes({
      ...dataRes, [e.target.name]: e.target.value
    })
  }
  useEffect(async () => {
    if (noStatus) {
      let userData = [];
      if (dataRes != {}) {
        userData.push({
          loginSource: "google",
          firstName: dataRes.givenName,
          lastName: dataRes.familyName,
          userEmail: dataRes.email,
          Title: "userID",
          titleValue: dataRes.googleId,
          phoneNo: dataRes.phone_no
        });
        let resg = await socialRegisterApi(
          userData,
          appDispatch,
          loginHandleclose,
          loading,
          setLoading,
          getPhoneNo
        );
        setNoStatus(false)
        // console.log(resg, "successfull");
      }
    }
  }, [noStatus]);

  return (
    <React.Fragment>
      <GetPhoneNo
        handleClose={handleClosePhoneNo}
        loginClose={loginHandleclose}
        open={open}
        setNoStatus={setNoStatus}
        handleChangeUserInfo = {handleChangeUserInfo}      
        purpose="Google" dataRes={dataRes}
      />
      <div className={`text-center  ${appState.langValue === "ar" ? "pr-md-1" : "pl-md-1"}`} >
        <GoogleLogin
          clientId={clientId}
          buttonText="Login"
          onSuccess={responseGoogle}
          onFailure={onFailureSuccess}
          cookiePolicy={"single_host_origin"}
          render={(renderProps) => (
             <Button
             className=" googleBtn py-3 familyManrope800 d-flex  justify-content-sm-center"
             onClick={renderProps.onClick}
             variant="contained"
           >
             <span className="px-2">
               <img src={google} alt="" />
             </span>
             <span> 
             {t("form.login-with-google")}
             </span>
           </Button>
          )}
        />
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(LoginGoogle);
